export default function CornerMarkIntegral({
    item = {},
    priceMember,
    priceNormal,
    priceCompareAt,
    TextA = {},
}: {
    item: any;
    priceMember: number;
    priceNormal: number;
    priceCompareAt: number;
    TextA: any;
}) {
    const integralCornerMarkerType = item.integralCornerMarkerType || '';
    const isScaleType = integralCornerMarkerType === 'IntegralCornerMarkerScale';
    if (isScaleType) {
        const IntegralCornerMarkerScaleNum = item.IntegralCornerMarkerScaleNum || 0;
        const IntegralCornerMarkerScaleType = item.IntegralCornerMarkerScaleType; //哪种价格
        let priceNumber = 0;
        if (IntegralCornerMarkerScaleType === 'member') {
            priceNumber = priceMember;
        } else if (IntegralCornerMarkerScaleType === 'normal') {
            priceNumber = priceNormal;
        } else if (IntegralCornerMarkerScaleType === 'compareAt') {
            priceNumber = priceCompareAt;
        }
        const IntegralCornerMarkerScaleVal = item.IntegralCornerMarkerScaleVal; //比例
        const ecoCreditsVal = parseInt(`${(priceNumber * IntegralCornerMarkerScaleVal * IntegralCornerMarkerScaleNum) / 100 || 0}`);
        return (
            <div className="member-product-scene-item-corner-mark-integral member-product-scene-item-corner-mark-right">
                <span className="member-product-scene-item-corner-mark-integral-l">
                    {IntegralCornerMarkerScaleNum}
                    {TextA.EcoCreditsX}
                </span>
                <span className="member-product-scene-item-corner-mark-integral-r">
                    {ecoCreditsVal}
                    {TextA.EcoCreditsNum}
                </span>
            </div>
        );
    }
    return null;
}
